import useNetwork from "./Network.hook";

export default useNetwork;
